<template>
  <div>
    <!-- Modal -->
    <div 
      class="modal fade" 
      id="modalReturnTicketQcDone" 
      tabindex="-1" 
      role="dialog" 
      aria-labelledby="returnTicketQcDoneModalLabel" 
      ref="modal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h5 class="modal-title" id="qcDoneModalLabel">QC Done</h5>
            <button type="button" class="close" @click="closeModal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <!-- Order Info -->
            <div class="mb-3">
              <h6 class="font-weight-bold mb-2">Ticket Number</h6>
              <!-- {{ orderData }} -->
              <div class="p-3 bg-light rounded border-card">
                <!-- <div class="mb-1">{{ orderData.ticketNo }}</div> -->
                <div v-if="orderData.ticketNo" class="text-primary" style="cursor: pointer;" @click="toTicketDetail(orderData.ticketId)">{{orderData.ticketNo}}</div>
              </div>
            </div>

            <!-- untuk yang punya batch number -->
            <div>
              <div class="mb-3">
              <h6 class="font-weight-bold mb-2">Product Info</h6>
                <div class="p-3 bg-light rounded border-card">
                  <!-- Category label -->
                  <div class="text-muted small mb-1">Parts</div>
                  <!-- Item Name -->
                  <div class="font-weight-bold mb-3">
                    {{ ticketData.productName ? ticketData.productName : '-' }}
                  </div>
                  <!-- Detail Grid -->
                  <div class="row">
                    <div class="col-6 mb-2">
                      <div class="text-muted small">Product Code</div>
                      <div>{{ticketData.itemCode ? ticketData.itemCode || '-' : '-' }}</div>
                    </div>
                    <div class="col-6 mb-2">
                      <div class="text-muted small">Serial Number</div>
                      <div>{{ ticketData ? ticketData.serialNumber || '-' : '-' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="text-muted small">Stock Code</div>
                      <div>{{ ticketData ? ticketData.stockCode || '-' : '-' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="text-muted small">Batch Number</div>
                      <div>{{ ticketData? ticketData.batchNo || '-' : '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Warehouse -->
             <div class="row mb-3">
              <div class="col-6">
                <label class="section-title">Hasil QC</label>
                <select 
                  class="form-control custom-select" 
                  v-model="hasilQC"
                >
                  <option value="" disabled>Pilih Hasil QC</option>
                  <option value="none">None</option>
                  <option value="ready stock">Ready Stock</option>
                  <option value="trouble stock">Trouble Stock</option>
                </select>
              </div>
              <div class="col-6">
                <label class="section-title">Warehouse</label>
                <select 
                  class="form-control custom-select"
                  v-model="warehouse"
                  :disabled="!hasilQC || hasilQC === 'none'"
                >
                  <option value="">Pilih Warehouse</option>
                  <option v-for="wh in warehouseList" :key="wh" :value="wh">{{ wh }}</option>
                </select>
              </div>
            </div>

          </div>
          <!-- Modal Footer -->
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Cancel
            </button>
            <button v-if="!processingSubmitReq" type="button" class="btn btn-primary" @click="submitHLP" :disabled="!hasilQC || !warehouse">
              Save
            </button>
            <button  v-else type="button" class="btn btn-primary btn-sm" disabled>Menyimpan...</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Swal from "sweetalert2";
export default {
  name: 'ModalReturnTicketQcDone',
  props: ['orderData','ticketData','toTicketDetail','warehouseList'],
  components: {
    Multiselect,
  },
  data() {
    return {
      warehouse : '',
      warehouseTrouble : '',
      hasilQC : '',
      processingSubmitReq: false,
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
    }
  },
  computed: {
    totalQC() {
      return this.qcReadyStock + this.qcTrouble;
    }
  },
  methods: {
    showModal() {
      $(this.$refs.modal).modal('show');
    },
    closeModal() {
      this.warehouse = '',
      this.warehouseTrouble = '',
      this.hasilQC = ''
      $(this.$refs.modal).modal('hide');
    },

    submitHLP() {
      this.processingSubmitReq = true
      let order = this.orderData
      this.itemGroup = order.itemGroup

      this.$http.post(process.env.QC_DONE, {
          data: {
            actualSpec: order.actualSpec,
            orderDetailsId: order.orderDetailsId,
            productCode: order.productCode ? order.productCode.replace(this.spaceRegex, ' ') : order.productCode,
            productName: order.productName ? order.productName.replace(this.spaceRegex, ' ') : order.productName,
            serialNumber: this.ticketData.serialNumber ? this.ticketData.serialNumber.replace(this.spaceRegex, ' ') : this.ticketData.serialNumber,
            spec: order.spec,
            stockCode: this.ticketData.stockCode,
            stockId: this.ticketData.stockId,
            companyName: order.companyName ? order.companyName.replace(this.spaceRegex, ' ') : order.companyName,
            companyId: order.companyId,
            ticketDeviceId: this.ticketData.ticketDeviceId,
            ticketId: order.ticketId,
            ticketNo: order.ticketNo,
            orderCode: order.orderCode,
            returnBy: order.returnBy,
            bomId: this.ticketData.bomId || null,
            bomItem: this.ticketData.bomItem,
            fromWarehouse: order.fromWarehouse,
            orderAcc: order.orderAcc,
            itemGroup: this.ticketData.itemGroup,
            batchNo: this.ticketData.batchNo,
          },
          status: this.hasilQC,
          parentWarehouse: this.warehouse,
        }, { 
          headers: { "Asani-Token": localStorage.getItem("jwt") },
          timeout : 300 * 1000, 
        })
        .then(res => {
          console.log(res)
          if (res.data.status == 200) {
            swal('Sukses', 'Data berhasil disimpan', 'success').then(() => {
              this.processingSubmitReq = false
              window.location.reload()
            })
          } else {
            swal('Error', res.data.message, 'error')
            this.processingSubmitReq = false
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
            this.processingSubmitReq = false
          })
        })
    },
  },
  watch: {

  },
}
</script>

<style scoped>
.wh-trouble {
  background-color: #F8F9FA;
}
.modal-header {
  border-bottom: 1px solid #dee2e6;
}

.modal-footer {
  border-top: 1px solid #dee2e6;
}

.border-card {
  border: 1px solid  #D1D9E2;;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.font-weight-bold {
  font-weight: 600;
}

h6 {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/QC/CustomComponent/ModalReturnTicketQcDone.vue